<template>
  <div
    class="search-form"
    @mouseover="showProductList=true"
    @mouseout="showProductList=false"
  >
    <input class="search-form__input" placeholder="输入您想要估价的机型" v-model="key">
    <button class="search-form__button" @click="toSearch">
      <i class="search-form__icon-search"></i>
    </button>
    <ul class="product-list" v-show="showProductList">
      <li
        class="product-item"
        v-for="(item, index) in productList"
        :key="index"
        @click="$router.push('/evaluate/'+item.productId+'.html')"
      >
        <span class="product-name">{{ item.productName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { getProductsByKey } from '@/apis/base';

export default {
  data () {
    return {
      key: '',
      showProductList: false,
      productList: []
    };
  },
  watch: {
    key (key) {
      this.getProductsByKey();
    }
  },
  methods: {
    async getProductsByKey () {
      let result = await getProductsByKey(this.key, 1, 10);
      if (result._errCode === '0') {
        this.productList = result._data.productList;
      }
    },
    toSearch () {
      if (this.key) {
        this.$router.push('/search?key=' + this.key);
      }
    }
  },
  async mounted () {
    this.key = this.$route.query.key || '';
    // this.getProductsByKey();
  }
};
</script>

<style lang="postcss" scoped>
.search-form {
  position: relative;
  float: right;
  margin-top: 20px;
  border: 1px solid #fabe00;
  &__input {
    float: left;
    width: 260px;
    height: 46px;
    padding: 0 10px;
    border: 0;
    outline: 0;
    box-sizing: border-box;
  }
  &__button {
    float: left;
    width: 58px;
    height: 46px;
    border: none;
    outline: 0;
    cursor: pointer;
    background-color: #fabe00;
  }
  &__icon-search {
    display: block;
    width: 19px;
    height: 21px;
    margin: 0 auto;
    background-position: -50px 0px;
    background-repeat: no-repeat;
    background-image: url(//www.huishoubao.com/static/pc/1001/img/sprite.png);
  }
}

.product {
  &-list {
    z-index: 100;
    position: absolute;
    top: 46px;
    left: -1px;
    width: 320px;
    background-color: #fff;
    border: 1px solid #fabe00;
  }
  &-item {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 12px;
    line-height: 30px;
    color: #999;
    cursor: pointer;
    &:hover {
      color: #3b9bff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/search-form/index.vue